import { UntypedFormControl, ValidationErrors } from "@angular/forms";

export function signatureValidator(control: UntypedFormControl): ValidationErrors | undefined {
  if (!validSignature(control.value)) {
    return {
      invalidSignature: true,
    };
  }

  function validSignature(value: string) {
    const pattern = "^[A-Za-z0-9]{8}-[A-Za-z0-9]{8}-[A-Za-z0-9]{8}-[A-Za-z0-9]{8}$";
    return new RegExp(pattern).test(value);
  }
}
